<template>
  <div>
    <div class="headline primary--text mb-3">Number of Case by Agent & Bot</div>
    <v-layout :style="{ margin: '-8px' }" wrap>
      <v-flex class="pa-2" xs12 xl9>
        <Apexchart v-if="isMounted" :height="320" :options="options" :series="series" />
      </v-flex>
      <v-flex class="pa-2" xs12 xl3>
        <v-card color="grey lighten-3">
          <v-card-text>
            <v-layout :style="{ margin: '-8px' }" wrap>
              <v-flex class="pa-2" xs12 sm4 xl12>
                <div class="resize-header">Total</div>
                <div class="resize-value">
                  <template v-if="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </template>
                  <template v-else>{{ total }}</template>
                </div>
              </v-flex>
              <v-flex class="pa-2" xs12 sm4 xl12>
                <div class="resize-header">Closed by bot</div>
                <div class="resize-value">
                  <template v-if="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </template>
                  <template v-else
                    >{{ closedByBot }} ({{
                      isNaN(closedByBotPercent) ? 0 : closedByBotPercent
                    }}%)</template
                  >
                </div>
              </v-flex>
              <v-flex class="pa-2" xs12 sm4 xl12>
                <div class="resize-header">Closed by agent</div>
                <div class="resize-value">
                  <template v-if="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </template>
                  <template v-else
                    >{{ closedByAgent }} ({{
                      isNaN(closedByAgentPercent) ? 0 : closedByAgentPercent
                    }}%)</template
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Apexchart from 'vue-apexcharts'

export default {
  components: {
    Apexchart
  },
  props: {
    filter: {
      type: Object,
      default: () => ({
        startTime: undefined,
        endTime: undefined,
        role: undefined,
        channel: undefined,
        search_page_id: undefined
      })
    },
    closedByBot: {
      type: Number,
      default: 0
    },
    closedByAgent: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: true
    },
    botData: {
      type: Array,
      default: () => []
    },
    agentData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isMounted: false,
      options: {
        chart: {},
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false
          }
        }
      }
    }
  },
  computed: {
    series() {
      return [
        {
          name: 'Bot',
          data: this.botData.map((item) => [item.date, item.count])
        },
        {
          name: 'Agent',
          data: this.agentData.map((item) => [item.date, item.count])
        }
      ]
    },
    closedByBotPercent() {
      return Math.round((this.closedByBot / this.total) * 100)
    },
    closedByAgentPercent() {
      return Math.round((this.closedByAgent / this.total) * 100)
    }
  },
  async mounted() {
    this.isMounted = true
    // this.loading = true
    // await this.handlePostChatlogCountAgentBot()
    // this.loading = false
  }
}
</script>

<style lang="css" scoped>
/* .resize-header {
  font-size: 16px !important;
  font-weight: 400;
}
.resize-value {
  font-size: 24px !important;
  line-height: 32px !important;
}
@media screen and (min-width: 1560px) { */
.resize-header {
  font-size: 20px !important;
}
.resize-value {
  font-size: 32px !important;
  font-weight: bold !important;
}
/* } */
</style>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Overview/AgentStatistics.vue